import IconTemplate from '../IconTemplate';
export default IconTemplate('M16 13h-3V3h-2v10H8l4 4 4-4zM20 15v4H4V15H2v6H22V15z');